exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n* {\n    font-family: BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif;\n}\n.pl-content {\n    color: #373a3c;\n}\napp-root {\n    display: block;\n    min-height: calc(100%-90px); height: calc(100%-90px);\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/node_modules/css-loader?{"sourceMap":false,"import":false}!/home/pneuser/workspace/pepelogistic/pepeLogisticControl/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!/home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"import":false}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../../src/styles.css
// module chunks = styles